import React from 'react'
import Analytics_Layout from './EnergyAnalytics';
 function PlantRoomEnergyAnalytics() {
  return (
    <div>
      <Analytics_Layout/>
    </div>
  )
}
export default PlantRoomEnergyAnalytics